import { use } from "react";
import { PreferencesContext } from "./context";

export function usePreferences() {
  const preferences = use(PreferencesContext);
  if (!preferences) throw new Error("usePreferences must be used within PreferencesProvider");
  return preferences;
}

